// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { formatToMoney } from '@advisor-app/features/utils/format-to-money';
import { Heading, SectionContainer } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';

interface BrokerBuyingPowerProps {
  buyingPower: number | undefined;
  cash: number | undefined;
}

export const BrokerBuyingPower = ({
  buyingPower,
  cash,
}: BrokerBuyingPowerProps) => {
  return (
    <SectionContainer>
      {buyingPower && cash ? (
        <div className="flex justify-between">
          <Heading
            variant="h2"
            title={
              <Translation i18nKey="dashboard.cash-buying-power" ns="dashboard" />
            }
            popupName="dashboard.cashAndBuyPower"
            tooltip
          />
          <Heading
            variant="h2"
            className="!money-display"
            title={`${formatToMoney(cash)} / ${formatToMoney(buyingPower)}`}
          />
        </div>
      ) : (
        <span className="block text-center text-lg font-semibold text-neutral-500">
          <Translation i18nKey="dashboard.no-data-exists" ns="dashboard" />
        </span>
      )}
    </SectionContainer>
  );
};
